<style lang="scss" src='./Search.scss' scoped></style>
<template src="./Search.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
  } from "vuex";
  import ProductsGrid from '@/components/productsGrid/ProductsGrid'
  export default {
    name: "Search",
    components: {
      ProductsGrid,
    },
    data() {
      return {
        promotions : false,
        page: 1,
        qty: 100,
        is_search: false,
        banner_categories: [],
      };
    },
    computed: {
      ...mapState("Main", ['productsSearch', 'loadings', 'searchParams', 'resultsParams']),
      ...mapGetters("Main", ['getSection', 'getCarousel', 'getSearchBanners']),
    },
    watch: {
      '$route.query': {
        handler: function (query) {
          this.page = 1;
          this.qty = 100;
          this.fnGetData(query);
          this.fnSetIsSearch(query);
        },
        deep: true,
        immediate: true
      },
      productsSearch: {
        handler: function (value) {
          let flags = [], output = [], l = value.length, i;
          for(i = 0; i < l; i++){
              if(value[i].category_id == null || flags[value[i].category_id]){
                continue;                 
              }
              flags[value[i].category_id] = true;
              output.push(value[i].category_id);
          }
          this.banner_categories = output;
        },
        deep: true,
      }
    },

    methods: {
      ...mapMutations('Main', ['setSearchParams']),
      ...mapActions('Main', ['fnApiGetProducts']),
      fnSetIsSearch(query){
        this.is_search = query.keys ? true : false;
      },
      fnGetSearchTitle() {
        let title = '';
        if(this.is_search){
          return this.$t('general.resultsFor') + ' ';
        }
        return '';
      },
      fnGetData(query) {
        let params = {
          categoryId: null,
          subcategoryId: null,
          keys: null,
        }
        if (query.promotions) {
          this.banner_categories = [];
          this.promotions = true;
          this.fnApiGetProducts([this.promotions, this.page, this.qty]);
        } else {
          this.promotions = false;
          if (query.keys) {
            params.keys = query.keys;
          }
          if (query.category) {
            params.categoryId = query.category;
            this.banner_categories = [parseInt(query.category)];
            if (query.subcategory) {
              params.subcategoryId = query.subcategory;
              this.setSearchParams({
                categoryId: query.category,
                subcategoryId: query.category,
              });
            }
          };
          this.setSearchParams(params);
          this.fnApiGetProducts([this.promotions, this.page, this.qty]);
        }
      },
      fnIsLastPage(){
        return this.resultsParams ? !this.resultsParams.next : true;
      },
      fnPrevPage(){
        if(this.page != 1){
          this.page--;
          this.fnApiGetProducts([this.promotions, this.page, this.qty]);
        }
      },
      fnNextPage(){
        this.page++;
        this.fnApiGetProducts([this.promotions, this.page, this.qty]);
      },
      fnGetTotal(){
        return this.resultsParams ? this.resultsParams.total : 0;
      },
      fnGetResultsRange(){
        const start = this.resultsParams ? ((this.resultsParams.page - 1) * this.qty + 1) : 1;
        const end = this.resultsParams ? ((this.resultsParams.page - 1) * this.qty + this.resultsParams.qty) : 1;
        return start + ' ' + this.$t('general.to') + ' ' + end;
      },
      fnBack(){
        this.$router.push({
          path: '/'
        });
      },
    },

    beforeCreate() {},

    created() {
      window.fbq('track', 'PageView');
    },

    mounted() {
      this.page = 1;
      this.qty = 100;
    },

    beforeDestroy() {},
  };

</script>
